module.exports = __webpack_public_path__ + "assets/img/timeLine_img5.d5067855.png";